var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 17,
    viewBox: "0 0 32 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L2.125 2.125L0 4.25L2.125 6.375L0 8.5L2.125 10.625L0 12.75H19.8333C19.8333 13.8772 20.2811 14.9582 21.0781 15.7552C21.8752 16.5522 22.9562 17 24.0833 17C25.2105 17 26.2915 16.5522 27.0885 15.7552C27.8856 14.9582 28.3333 13.8772 28.3333 12.75H31.1667V8.5C31.1667 6.9275 29.9058 5.66667 28.3333 5.66667H25.5L21.25 0H0ZM5.12833 2.125H13.4583V5.66667H4.42L3.00333 4.25L5.12833 2.125ZM15.5833 2.125H20.5417L23.3183 5.66667H15.5833V2.125ZM24.0833 10.625C24.6469 10.625 25.1874 10.8489 25.5859 11.2474C25.9844 11.6459 26.2083 12.1864 26.2083 12.75C26.2083 13.3136 25.9844 13.8541 25.5859 14.2526C25.1874 14.6511 24.6469 14.875 24.0833 14.875C23.5197 14.875 22.9792 14.6511 22.5807 14.2526C22.1822 13.8541 21.9583 13.3136 21.9583 12.75C21.9583 12.1864 22.1822 11.6459 22.5807 11.2474C22.9792 10.8489 23.5197 10.625 24.0833 10.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.c23778bd356edcd3f0cb611ca690d8d7.svg";
export { ForwardRef as ReactComponent };